<template>
    <v-card>
        <v-expansion-panels flat :value="0">
            <v-expansion-panel>
                <v-expansion-panel-header color="" class="text-uppercase" hide-actions>
                    <v-card-title  class="pa-0  text-family font-weight-black justify-center" style="word-break: break-word;">Resumen de la transacción</v-card-title>
                    <!-- <template v-slot:actions>
                        <v-icon class="icon" right color="white">$expand</v-icon>
                    </template> -->
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-card-text>
                        <label class="text-family">* Antes de realizar tu pago, revisa que los datos estén correctos.</label>
                        <v-divider class="mt-2"></v-divider>
                        <v-expansion-panels flat>
                            <v-expansion-panel v-for="procedure in checkoutData" :key="'checkout'+procedure.id"  >
                                <v-expansion-panel-header class="px-0">
                                    <template v-slot:actions>
                                        <v-icon class="icon" left>$expand</v-icon>
                                    </template>
                                    <div class="header font-weight-bold" >
                                        <div class="d-flex justify-space-between">
                                            <div class="text-family">{{ procedure.nombre_tramite }} </div>
                                            <div class="text-right text-family">{{ procedure.precio| currency }}</div>
                                        </div>

                                    </div>

                                </v-expansion-panel-header>
                                <v-expansion-panel-content color=" " class="transaction-concepts">
                                    <v-simple-table dense fixed-header>
                                        <tbody>
                                        <tr
                                            v-for="concept in procedure.conceptos"
                                            :key="concept.id"
                                        >
                                            <td class="text-family">{{ concept.concepto }}</td>
                                            <td class="text-right text-family">{{ concept.precio| currency }}</td>
                                        </tr>
                                        </tbody>
                                    </v-simple-table>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                        <div class="grey lighten-4" v-if="checkoutItemsNumber > 5">
                            <v-btn
                                color="normal"
                                width="100%"
                                height="50"
                                class="text-family"
                                text
                                x-small
                                @click="showAllItems()"
                            >
                                Ver todos los trámites  ({{checkoutItemsNumber}} elementos)

                                <v-icon right class="float-right grey--text text--darken-2">
                                    fas fa-angle-down
                                </v-icon>

                            </v-btn>
                        </div>
                        <v-divider class="mt-4 mb-4"></v-divider>

                        <div class="d-flex justify-space-between text-h6">
                            <div class="text-family text-uppercase">Total a pagar</div>
                            <div>{{checkoutTotal| currency}}</div>
                        </div>
                        <div class="d-flex">
                            <v-btn v-if="currentCartStep == 2"
                                width="46%"
                                :color="pantone"
                                class="mt-2 white--text text-family mr-2"
                                large
                                tile
                                @click="goBack()"
                                
                            >
                                Atras
                            </v-btn>
                            <v-btn
                                v-if="currentCartStep != 2"
                                width="100%"
                                :color="pantoneBlack"
                                class="mt-2 white--text text-family"
                                large
                                tile
                                @click="submitCart()"
                                
                            >
                                Continuar
                            </v-btn>
                            <v-btn
                                v-else
                                width="50%"
                                :color="pantoneBlack"
                                class="mt-2 white--text text-family"
                                large
                                tile
                                @click="submitCart()"
                                
                            >
                                Continuar
                            </v-btn>
                        </div>

                    </v-card-text>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </v-card>
</template>

<script>
export default {
    name: "Checkout",
    props: ['checkoutData', 'checkoutTotal', 'checkoutItemsNumber', 'submitCart', 'showAllItems','currentCartStep'],
    data() { 
        return{
            pantone: '#B08C55',
            pantoneBlack: '#15212F',
        }
    },
    methods:{
        goBack(){
            this.$router.push({name: 'portfolio', params: {step: this.currentCartStep-1}})
        }
    }
}
</script>

<style scoped>
.v-expansion-panel-header__icon{
    display: none;
}
</style>